import VehicleDetails from './VehicleDetails';
import VehicleImage from './VehicleImage';
import VehicleStats from './VehicleStats';
import VehicleText from './VehicleText';
import RegoPlate from './RegoPlate';
import CardBlock from './CardBlock';
import VehicleAvatar from './VehicleAvatar';

export {
	VehicleDetails,
	VehicleText,
	VehicleImage,
	VehicleStats,
	RegoPlate,
	CardBlock,
	VehicleAvatar
};



// WEBPACK FOOTER //
// ./src/components/vehicle/index.js